import { render } from "./DBViews.vue?vue&type=template&id=096409b8"
import script from "./DBViews.vue?vue&type=script&lang=js"
export * from "./DBViews.vue?vue&type=script&lang=js"

import "./DBViews.vue?vue&type=style&index=0&id=096409b8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__